import {
  BarChartSquarePlusIcon,
  ChevronDownIcon,
} from '@langchain/untitled-ui-icons';

import { Dispatch, SetStateAction, useCallback } from 'react';

import { FeedbackChip } from '@/components/FeedbackChips';
import { PopoverDropdownMenu } from '@/components/PopoverDropdownMenu';

import { DatasetSessionCompareBarChartSpec } from '../constants';

export const SummaryChartsDropdown = ({
  barChartSpecs,
  selectedCharts,
  setSelectedCharts,
}: {
  barChartSpecs: DatasetSessionCompareBarChartSpec[] | null;
  selectedCharts: DatasetSessionCompareBarChartSpec[] | null;
  setSelectedCharts: Dispatch<
    SetStateAction<DatasetSessionCompareBarChartSpec[]>
  >;
}) => {
  const onSelectSummaryCharts = useCallback(
    (value: DatasetSessionCompareBarChartSpec) => {
      setSelectedCharts((prev) => {
        const isSelected = prev?.some(
          (chart) =>
            value.name === chart.name &&
            value.isFeedback === chart.isFeedback &&
            value.isSessionLevelFeedback === chart.isSessionLevelFeedback
        );

        if (isSelected) {
          return prev?.filter(
            (chart) =>
              value.name !== chart.name ||
              value.isFeedback !== chart.isFeedback ||
              value.isSessionLevelFeedback !== chart.isSessionLevelFeedback
          );
        }

        return [...(prev ?? []), value];
      });
    },
    [setSelectedCharts]
  );

  return (
    <PopoverDropdownMenu
      values={barChartSpecs ?? []}
      getSection={(value) =>
        value.isFeedback
          ? 'Evaluation Scores'
          : value.isSessionLevelFeedback
          ? 'Experiment Evaluation Scores'
          : value.isErrorRate || value.isLatency
          ? 'Performance'
          : 'Cost'
      }
      sectionsOrder={[
        'Evaluation Scores',
        'Experiment Evaluation Scores',
        'Performance',
        'Cost',
      ]}
      getIsSelected={(value) =>
        selectedCharts?.some(
          (chart) =>
            value.name === chart.name &&
            value.isFeedback === chart.isFeedback &&
            value.isSessionLevelFeedback === chart.isSessionLevelFeedback
        ) ?? false
      }
      getTitle={(value) => value.name}
      getRowTitleComponent={(value) =>
        value.isFeedback || value.isSessionLevelFeedback ? (
          <FeedbackChip
            feedback_key={value.name}
            allowTruncation
            className="border-none bg-transparent px-0"
            startDecorator={<></>}
          />
        ) : undefined
      }
      alignOffset={0}
      onSelect={(value) => {
        onSelectSummaryCharts(value);
      }}
      enableSearch
      stayOpenOnSelect
      asChild
      key={'add-charts'}
    >
      <div className="flex cursor-pointer gap-[3px] rounded-md border border-secondary bg-background">
        <div className="flex items-center gap-2 rounded-[7px] border-secondary px-2 py-1 text-xs transition-colors hover:bg-secondary focus:outline-none">
          <BarChartSquarePlusIcon className="h-4 w-4" />
          <div className="inline-flex items-center gap-1 font-medium">
            Charts
          </div>
          <ChevronDownIcon className="h-4 w-4" />
        </div>
      </div>
    </PopoverDropdownMenu>
  );
};
